const companyName = 'Michael Adsit Technologies, LLC.'

export default companyName
